import React, { useState, useEffect } from 'react';

import {
    Header,
    Footer
} from "../../layout";

import {
    ProvidedAccountDetails,
    Match,
    MatchWithCaution,
    NoMatch,
    FirmSearch,
    FooterButton,
    Hello,
    SelectedFirm,
    SelectOffice
} from "../../form";

import UserService from '../../../components/auth/UserService';
import settingsService from '../../../services/settingsService';
import httpClient from '../../../services/httpClient'
import AppSwitcher from '../../AppSwitcher/AppSwitcher';
import FeatureFlagWrapper from "../../Feature/FeatureFlagWrapper";
import { FeatureFlagsConsumer } from '@lms/react-configuration/context/feature-flags';

const Form = () => {
    const [lawFirm, setLawFirm] = useState(null);
    const [myName, setMyName] = useState(null);
    const [selectedOfficeId, setSelectedOfficeId] = useState(null);
    const [officeSelected, setOfficeSelected] = useState(false);
    const [offices, setOffices] = useState(null);
    const [isOptedOut, setIsOptedOut] = useState(false);
    const [termsSigned, setTermsSigned] = useState(false);
    const [termsNotSignedMessage, setTermsNotSignedMessage] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [sortCode, setSortCode] = useState('');
    const [match, setMatch] = useState('');
    const [pdfLink, setPdfLink] = useState(null);
    const [loggedInLawFirmName, setLoggedInLawFirmName] = useState('');
    const [officeNameProper, setOfficeNameProper] = useState('');
    const [hideValidationSortCode, setHideValidationSortCode] = useState(true);
    const [hideValidationAccountNumber, setHideValidationAccountNumber] = useState(true);
    const [error, setError] = useState(null);
    const [price, setPrice] = useState(null);
    const [matchesPreviousBankDetails, setMatchesPreviousBankDetails] = useState(false);

    useEffect(() => {
        if (selectedOfficeId == null) {
            //office not selected, set up and load page for office selection
            initPage();
        }
        else {
            //office has been selected, load prices for this office
            loadPrice(myName, selectedOfficeId).then(priceDetails => {
                setPrice(priceDetails.price);
            });
        }
    }, [myName, selectedOfficeId]);

    const initPage = () => {
        UserService.getUser(settingsService.authConfig).then(user => {
            setMyName(user.profile.sub);
            if (myName != null) {

                hasLawFirmSignedTerms(myName).then(signedTerms => {
                    setTermsSigned(signedTerms);
                    if (signedTerms) {
                        isLawFirmOptedOut(myName).then(optedOut => {
                            setIsOptedOut(optedOut);
                            if (!optedOut) {
                                getOffices(myName);
                                getLoggedInLawFirmName(myName);
                            }
                        });
                    }
                    else {
                        setTermsNotSignedMessage("Unfortunately you are unable to access confirmly at this time. This is due to your Law Firm's LMS Panel Membership Terms being outstanding. Please contact your Panel Membership Manager");
                    }
                });

            }
        });
    }

    const getOffices = async (username) => {
        if (error === null) {
            try {
                const domain = window.location.host;
                const configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                const endpoint = config.FunctionAppUrl + "/offices";
                httpClient.defaults.headers.common['Username'] = username;
                const response = await httpClient.get(endpoint);
                if (response.offices.length === 1) {
                    selectOfficeAutomaticallyIfOnlySingleOffice(response.offices[0].officeId);
                    setOfficeNameProper(response.offices[0].officeName);
                } else {
                    setOffices(response.offices);
                }
            } catch (e) {
                setError(
                    'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    const selectOfficeAutomaticallyIfOnlySingleOffice = (officeId) => {
        setSelectedOfficeId(officeId);
        setOfficeSelected(true);
    };

    const loadPrice = async (username, officeId) => {
        if (error === null) {
            try {
                const domain = window.location.host;
                const configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                const endpoint = config.FunctionAppUrl + "/pricing/branch/" + officeId;
                httpClient.defaults.headers.common['Username'] = username;
                const response = await httpClient.get(endpoint);
                return response;
            } catch (e) {
                setError(
                    'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    const isLawFirmOptedOut = async (username) => {
        if (error === null) {
            try {
                const domain = window.location.host;
                const configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                const endpoint = config.FunctionAppUrl + "/lawfirmOptedOut";
                httpClient.defaults.headers.common['Username'] = username;
                const response = await httpClient.get(endpoint);
                return response;
            } catch (e) {
                setError(
                    'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    const hasLawFirmSignedTerms = async (username) => {
        if (error === null) {
            try {
                const domain = window.location.host;
                const configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                const endpoint = config.FunctionAppUrl + "/lawfirmSignedTerms";
                httpClient.defaults.headers.common['Username'] = username;
                const response = await httpClient.get(endpoint);
                return response;
            } catch (e) {
                setError(
                    'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    const getLoggedInLawFirmName = async (username) => {
        if (error === null) {
            try {
                const domain = window.location.host;
                const configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                const endpoint = config.FunctionAppUrl + "/lawfirmname";
                httpClient.defaults.headers.common['Username'] = username;
                const response = await httpClient.get(endpoint);
                setLoggedInLawFirmName(response);
            } catch (e) {
                setError(
                    'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    const updateMatch = (match) => {
        setMatch(match);

        //THE MATCH CAN BE BLANK OR HAVE AN ERROR IN IT
        //IF THIS IS THE CASE, WE DON'T WANT TO SCROLL TO THE COMPONENT
        const acceptedMatchResponses = ["Match", "No Match", "Match with Cautions"];
        if (acceptedMatchResponses.indexOf(match) < 0) return;

        const scrollToElement = document.getElementById("div-form-component");
        scrollToElement.scrollIntoView({ behavior: "smooth" });
    };

    if (error !== null)
        return (
            <>
                <Header />
                <div className="row pt-3 mt-3">
                    <div className="col-12 text-danger">
                        {error}
                    </div>
                </div>
                <Footer />
            </>
        )

    return (
        <div id="div-form-component" data-testid="form-screen-component">

            <FeatureFlagWrapper>
                <FeatureFlagsConsumer>
                    <>
                        <AppSwitcher />

                        <Header />

                        {!termsSigned ? (<>
                            <br></br>
                            {termsNotSignedMessage}
                        </>) : (
                            isOptedOut ? (<>
                                Your Law Firm has opted out of using confirmly. To opt back in, please email confirmly@lms.com
                            </>) : (
                                <div>
                                    {
                                        match !== 'No Match' && match !== 'Match' && match !== 'Match with Cautions' &&
                                        <>
                                            <Hello userName={myName} />
                                            {lawFirm ? (null) : (
                                                <>
                                                    <SelectOffice offices={offices} selectedOfficeId={selectedOfficeId} setSelectedOfficeId={setSelectedOfficeId} officeSelected={officeSelected} setOfficeSelected={setOfficeSelected} officeNameProper={officeNameProper} setOfficeNameProper={setOfficeNameProper} />
                                                </>
                                            )}
                                        </>
                                    }
                                    {!officeSelected ? (null) : (
                                        <>
                                            {match === '' ? (
                                                <FirmSearch lawFirm={lawFirm} setLawFirm={setLawFirm} selectedOfficeId={selectedOfficeId} userName={myName} loggedInLawFirmName={loggedInLawFirmName} />
                                            ) : (null)}
                                            {lawFirm === null ? (null) : (
                                                <>
                                                    {
                                                        match !== 'No Match' && match !== 'Match' && match !== 'Match with Cautions' ?
                                                            (
                                                                <>
                                                                    <SelectedFirm lawFirm={lawFirm} setLawFirm={setLawFirm} />
                                                                    <ProvidedAccountDetails setAccountNumber={setAccountNumber} setSortCode={setSortCode} hideValidationAccountNumber={hideValidationAccountNumber} hideValidationSortCode={hideValidationSortCode} price={price} />
                                                                </>
                                                            ) :
                                                            (
                                                                <>
                                                                    <NoMatch lawFirm={lawFirm} accountNumber={accountNumber} sortCode={sortCode} match={match} pdfLink={pdfLink} userName={myName} loggedInLawFirmName={loggedInLawFirmName} matchesPreviousBankDetails={matchesPreviousBankDetails} />
                                                                    <Match lawFirm={lawFirm} accountNumber={accountNumber} sortCode={sortCode} match={match} pdfLink={pdfLink} userName={myName} loggedInLawFirmName={loggedInLawFirmName} />
                                                                    <MatchWithCaution lawFirm={lawFirm} accountNumber={accountNumber} sortCode={sortCode} match={match} pdfLink={pdfLink} userName={myName} loggedInLawFirmName={loggedInLawFirmName} />
                                                                </>
                                                            )
                                                    }
                                                    <FooterButton lawFirm={lawFirm} setLawFirm={setLawFirm} selectedOfficeId={selectedOfficeId} accountNumber={accountNumber} setAccountNumber={setAccountNumber} sortCode={sortCode} setSortCode={setSortCode} match={match} updateMatch={updateMatch} setPdfLink={setPdfLink} userName={myName} loggedInLawFirmName={loggedInLawFirmName} setHideValidationAccountNumber={setHideValidationAccountNumber} setHideValidationSortCode={setHideValidationSortCode} setMatchesPreviousBankDetails={setMatchesPreviousBankDetails} />
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>)
                        )
                        }


                        <Footer />
                    </>
                </FeatureFlagsConsumer>
            </FeatureFlagWrapper>

        </div>);
};
export default Form;